'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './referral-recent.routes';

export class ReferralRecentComponent {
  constructor(ReferralService, dialogs, DTOptionsBuilder, DTColumnDefBuilder, $uibModal, $stateParams, Auth) {
    'ngInject';
    this.ReferralService = ReferralService;
    this.data = [];
    this.isAdmin = Auth.isAdminSync;
    this.Auth = Auth;

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;

    this.formName = $stateParams.name;

    this.data = ReferralService.query();

    jQuery(document).ready(function() {
      jQuery.extend(jQuery.fn.dataTableExt.oSort, {
        "extract-date-pre": function (value) {
          return moment(value).toDate()
        },
        "extract-date-asc": function (a, b) {
          return ((a < b) ? -1 : ((a > b) ? 1 : 0));
        },
        "extract-date-desc": function (a, b) {
          return ((a < b) ? 1 : ((a > b) ? -1 : 0));
        }
      });
    });

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('responsive', true)
      .withOption('order', [0, 'desc'])
      .withOption('pageLength', 25)
      .withOption('columnDefs', [{
        type: 'extract-date',
        targets: [0]
      }])
      .withOption('buttons',[{
        extend: 'excel',
        title: 'Recent Referrals as of ' + moment().format("MMMM Do YYYY")
      },{
        extend: 'csv',
        title: 'Recent Referrals as of ' + moment().format("MMMM Do YYYY")
      },{
        title: 'Recent Referrals',
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'landscape',
        pageSize: 'LETTER'
      },'print']);
  }

  delete(referral) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'reasonForm',
      resolve: {
        config: function() {
          return {

          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      reason => {

        that.ReferralService.deleteAndNotify({id: referral._id}, {reason: reason}, _ => {
          that.data = that.ReferralService.query();
        })

      },
      () => { /* cancel */ }
    );

  }
}

export default angular.module('conduuApp.referralRecent', [uiRouter])
  .config(routes)
  .component('referralRecent', {
    template: require('./referral-recent.html'),
    controller: ReferralRecentComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/referral/recent/referral-recent.component.js